import React, { useState } from "react";
import Sidebar from "../../Layout/Sidebar";
import Navbar from "../../Layout/Navbar";
import ClientsTable from "./ClientsTable";
import AdminSidebar from "../../Layout/AdminSidebar";

const ClientPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const userRole = localStorage.getItem("role");
  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <div className="flex flex-1 w-full">
        {/* Conditionally render AdminSidebar or Sidebar based on userRole */}
        {userRole === "admin" ? (
          <AdminSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        ) : (
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        )}

        {/* Main content area */}
        <div
          className={`flex-1 p-2 transition-all overflow-hidden duration-300 ease-in-out ${
            isSidebarOpen ? "md:ml-52 ml-0" : "ml-0"
          }`}
        >
          {/* Navbar */}
          <Navbar toggleSidebar={toggleSidebar} />
          {/* <br /> */}

          {/* Page content */}
          <div className="content flex-1 max-w-full">
            <ClientsTable />
          </div>
        </div>
      </div>

      {/* Responsive Footer */}
      <footer className="bg-gray-800 text-white text-center sm:text-right p-2 mt-auto shrink-0 w-full">
        <p className="text-sm">
          Designed with ❤️ and crafted with care by Team{" "}
          <a
            href="https://www.youtube.com/@SHALENDERSINGH"
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-500 font-bold block sm:inline hover:text-yellow-600"
          >
            SMART ITBOX
          </a>
        </p>
      </footer>
    </div>
  );
};

export default ClientPage;
